/**
 * Artists index: `artist` metaobjects via Storefront API, client-side filters and load-more (16 per page).
 */
(function () {
  function getArtistIndexHeaderOffset() {
    var offset = 16;

    var announcement = document.querySelector(
      '.announcement-bar__outer-wrapper'
    );

    var header = document.querySelector(
      '.shopify-section.header__outer-wrapper'
    );

    if (announcement) {
      offset += Math.ceil(
        announcement.getBoundingClientRect().height
      );
    }

    if (header) {
      offset += Math.ceil(
        header.getBoundingClientRect().height
      );
    }

    return offset;
  }

  function getArtistIndexScrollTarget() {
    /*
     * Prefer the visible filter toolbar. The zero-height marker remains the
     * canonical URL anchor, but targeting visible UI avoids browser clamping
     * and inconsistent positioning when the Artist application is moved or
     * revealed asynchronously.
     */
    return document.querySelector('[data-artists-filter-bar]') ||
      document.querySelector('[data-artist-index-anchor]');
  }

  function revealArtistIndexPage() {
    document.documentElement.classList.remove(
      'artist-index-anchor-pending'
    );
  }

  function scrollToArtistIndexInterface() {
    var target = getArtistIndexScrollTarget();
    if (!target) return false;

    var top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getArtistIndexHeaderOffset();

    var maxTop = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight
    );

    window.scrollTo({
      top: Math.max(0, Math.min(top, maxTop)),
      behavior: 'auto'
    });

    return true;
  }

  function restoreArtistIndexHash() {
    history.replaceState(
      history.state,
      '',
      window.location.pathname +
        window.location.search +
        '#artist-index'
    );
  }

  function restoreInitialArtistIndexAnchor() {
    var state = window.__maddoxArtistIndexAnchor;

    if (!state || !state.pending) {
      return;
    }

    if (!getArtistIndexScrollTarget()) {
      revealArtistIndexPage();
      return;
    }

    state.pending = false;

    var fontsReady =
      document.fonts && document.fonts.ready
        ? document.fonts.ready.catch(function () {})
        : Promise.resolve();

    fontsReady.then(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          scrollToArtistIndexInterface();
          restoreArtistIndexHash();

          if (
            'scrollRestoration' in history &&
            state.previousScrollRestoration !== null
          ) {
            history.scrollRestoration =
              state.previousScrollRestoration;
          }

          window.__maddoxArtistIndexAnchor = null;
          revealArtistIndexPage();

          /*
           * Correct only genuine late layout movement (fonts/images/sticky
           * header), without animated travel or an unconditional load jump.
           */
          [120, 400].forEach(function (delay) {
            window.setTimeout(function () {
              var target = getArtistIndexScrollTarget();
              if (!target) return;

              var expectedTop = getArtistIndexHeaderOffset();
              var actualTop = target.getBoundingClientRect().top;

              if (Math.abs(actualTop - expectedTop) > 12) {
                scrollToArtistIndexInterface();
              }
            }, delay);
          });
        });
      });
    });
  }

  document.addEventListener(
    'artists:index-ready',
    restoreInitialArtistIndexAnchor,
    { once: true }
  );

  /*
   * Menu links can become same-document navigation when the visitor is
   * already on the Artist Index page. Intercept that case so the browser does
   * not perform an un-offset native hash jump to the bottom scroll boundary.
   */
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href*="#artist-index"]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (
        url.hash !== '#artist-index' ||
        url.origin !== window.location.origin ||
        url.pathname !== window.location.pathname ||
        url.search !== window.location.search
      ) {
        return;
      }

      if (!getArtistIndexScrollTarget()) return;

      event.preventDefault();
      history.pushState(history.state, '', url.pathname + url.search + url.hash);
      window.requestAnimationFrame(scrollToArtistIndexInterface);
    },
    true
  );

  window.addEventListener('hashchange', function () {
    if (window.location.hash !== '#artist-index') return;
    window.requestAnimationFrame(scrollToArtistIndexInterface);
  });

  var QUERY = [
    'query ArtistsIndex($type: String!, $first: Int!, $after: String) {',
    '  metaobjects(type: $type, first: $first, after: $after) {',
    '    pageInfo { hasNextPage endCursor }',
    '    edges {',
    '      node {',
    '        handle',
    '        name: field(key: "name") { value }',
    '        nationality: field(key: "nationality") { value }',
    '        category: field(key: "category") { value }',
    '        medium: field(key: "medium") { value }',
    '        featured_order: field(key: "featured_order") { value }',
    '        date_added: field(key: "date_added") { value }',
    '        portrait: field(key: "portrait") {',
    '          value',
    '          reference {',
    '            __typename',
    '            ... on MediaImage {',
    '              image { url(transform: { maxWidth: 900 }) altText }',
    '            }',
    '          }',
    '        }',
    '        secondary_hover_image: field(key: "secondary_hover_image") {',
    '          value',
    '          reference {',
    '            __typename',
    '            ... on MediaImage {',
    '              image { url(transform: { maxWidth: 900 }) altText }',
    '            }',
    '          }',
    '        }',
    '        artists_page: field(key: "artists_page") {',
    '          value',
    '          reference {',
    '            __typename',
    '            ... on Collection { handle onlineStoreUrl }',
    '          }',
    '        }',
    '        collection: field(key: "collection") {',
    '          value',
    '          reference {',
    '            __typename',
    '            ... on Collection { handle onlineStoreUrl }',
    '          }',
    '        }',
    '      }',
    '    }',
    '  }',
    '}',
  ].join('\n');

  function parseList(val) {
    if (val == null || val === '') return [];
    if (Array.isArray(val)) return val.map(String).map(function (s) { return s.trim(); }).filter(Boolean);
    var s = String(val).trim();
    try {
      var j = JSON.parse(s);
      if (Array.isArray(j)) return j.map(String).map(function (x) { return x.trim(); }).filter(Boolean);
      if (j != null) return [String(j)];
    } catch (e) {
      /* fall through */
    }
    return s.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function parseBool(val) {
    if (val === true || val === false) return val;
    var s = String(val == null ? '' : val).toLowerCase().trim();
    return s === 'true' || s === '1' || s === 'yes';
  }

  function parseFeaturedOrder(val) {
    if (val == null || val === '') return null;
    var n = parseInt(val, 10);
    return isNaN(n) ? null : n;
  }

  function parseDateAdded(val) {
    if (val == null || val === '') return null;
    var t = Date.parse(val);
    return isNaN(t) ? null : t;
  }

  function imageFromField(field) {
    if (!field) return '';
    var ref = field.reference;
    if (ref && ref.image && ref.image.url) return ref.image.url;
    var v = field.value;
    if (v && /^https?:\/\//i.test(String(v))) return String(v);
    return '';
  }

  function imageAltFromField(field, fallback) {
    if (field && field.reference && field.reference.image && field.reference.image.altText) {
      return field.reference.image.altText;
    }
    return fallback || '';
  }

  function collectionUrlFromField(field) {
    if (!field) return '';
    var ref = field.reference;
    if (ref && ref.__typename === 'Collection') {
      if (ref.onlineStoreUrl) return ref.onlineStoreUrl;
      if (ref.handle) return '/collections/' + ref.handle;
    }
    var v = field.value;
    if (v) {
      v = String(v).trim();
      if (/^https?:\/\//i.test(v) || v.indexOf('/') === 0) return v;
    }
    return '';
  }


  function lookupArtistUrlFromMap(handle, artistUrlMap) {
    if (!artistUrlMap || !handle) return '';
    if (artistUrlMap[handle]) return artistUrlMap[handle];
    var normalized = String(handle).toLowerCase();
    var keys = Object.keys(artistUrlMap);
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].toLowerCase() === normalized) return artistUrlMap[keys[i]];
    }
    return '';
  }

  function isAvailableArtworksUrl(url) {
    return /\/collections\/available-works-by-/i.test(String(url || ''));
  }

  function resolveArtistPageUrl(node, artistUrlMap) {
    var mappedUrl = lookupArtistUrlFromMap(node.handle, artistUrlMap);
    if (mappedUrl && !isAvailableArtworksUrl(mappedUrl)) return mappedUrl;

    var artistPageUrl = collectionUrlFromField(node.artists_page);
    if (artistPageUrl && !isAvailableArtworksUrl(artistPageUrl)) return artistPageUrl;

    if (node.handle) return '/collections/' + encodeURIComponent(node.handle);
    return '#';
  }

  function escAttr(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function firstLetterBucket(name) {
    var normalized = String(name || '')
      .trim()
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/^Ł/, 'L')
      .replace(/^Ø/, 'O')
      .replace(/^Æ/, 'A')
      .replace(/^Œ/, 'O');
    if (!normalized) return '#';
    var c = normalized.charAt(0);
    if (c >= 'A' && c <= 'Z') return c;
    if (c >= '0' && c <= '9') return '0-9';
    return '#';
  }

  function normalizeArtist(node, artistUrlMap) {
    var nameField = node.name;
    var name = nameField && nameField.value != null ? String(nameField.value).trim() : node.handle || 'Artist';
    var portraitUrl = imageFromField(node.portrait);
    var hoverUrl = imageFromField(node.secondary_hover_image);
    var natVal = node.nationality && node.nationality.value;
    var nationality = natVal != null && String(natVal).trim() !== '' ? parseList(natVal) : [];
    if (nationality.length === 0 && natVal) nationality = [String(natVal).trim()];

    return {
      handle: node.handle,
      name: name,
      portraitUrl: portraitUrl,
      portraitAlt: imageAltFromField(node.portrait, name) || name,
      hoverUrl: hoverUrl,
      hoverAlt: imageAltFromField(node.secondary_hover_image, name) || name,
      collectionUrl: resolveArtistPageUrl(node, artistUrlMap),
      nationality: nationality,
      category: parseList(node.category && node.category.value),
      medium: normaliseMediumList(parseList(node.medium && node.medium.value)),
      featuredOrder: parseFeaturedOrder(node.featured_order && node.featured_order.value),
      dateAdded: parseDateAdded(node.date_added && node.date_added.value),
      letter: firstLetterBucket(name),
    };
  }

  function getConnectionPayload(data) {
    var mo = data && data.data && data.data.metaobjects;
    if (!mo) return { nodes: [], pageInfo: {} };
    if (mo.edges && mo.edges.length) {
      return {
        nodes: mo.edges.map(function (e) { return e.node; }),
        pageInfo: mo.pageInfo || {},
      };
    }
    if (mo.nodes && mo.nodes.length) {
      return { nodes: mo.nodes, pageInfo: mo.pageInfo || {} };
    }
    return { nodes: [], pageInfo: mo.pageInfo || {} };
  }


  var MEDIUM_ALIASES = {
    "mixed media": "Mixed Media",
    "mixed-media": "Mixed Media",
    "mixed media art": "Mixed Media",
    "mixed mediums": "Mixed Media",
    "painting": "Painting",
    "paintings": "Painting",
    "sculpture": "Sculpture",
    "sculptures": "Sculpture",
    "photograph": "Photography",
    "photographs": "Photography",
    "photography": "Photography",
    "print": "Print",
    "prints": "Print",
    "works on paper": "Works on Paper",
    "work on paper": "Works on Paper",
    "drawing": "Drawing",
    "drawings": "Drawing",
    "digital art": "Digital Art",
    "digital artwork": "Digital Art",
    "installation": "Installation",
    "installations": "Installation",
    "textile": "Textile",
    "textiles": "Textile"
  };

  var EXCLUDED_MEDIUM_KEYS = {
    "visual media": true,
    "visual artwork": true
  };

  function normaliseMediumLabel(value) {
    var label = String(value || "").trim().replace(/\s+/g, " ");
    if (!label) return "";
    var key = label.toLocaleLowerCase().replace(/[–—]/g, "-");
    if (EXCLUDED_MEDIUM_KEYS[key]) return "";
    return MEDIUM_ALIASES[key] || label;
  }

  function normaliseMediumList(values) {
    var seen = {};
    var output = [];
    (values || []).forEach(function (value) {
      var label = normaliseMediumLabel(value);
      if (!label) return;
      var key = label.toLocaleLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      output.push(label);
    });
    return output;
  }

  function uniqSort(arr) {
    var o = {};
    arr.forEach(function (x) {
      if (x) o[String(x).trim()] = true;
    });
    return Object.keys(o).sort(function (a, b) { return a.localeCompare(b); });
  }

  window.initArtistsIndex = function (sectionEl) {
    if (!sectionEl) return;
    var app = sectionEl.querySelector('[data-artists-index-root]');
    if (!app) return;
    if (app._artistsAbort) app._artistsAbort.abort();
    app._artistsAbort = new AbortController();
    var signal = app._artistsAbort.signal;

    var apiUrl = app.dataset.apiUrl;
    var token = app.dataset.token;
    var metaType = app.dataset.metaobjectType || 'artist';
    var artistUrlMap = {};
    var artistUrlsEl = app.querySelector('[data-artist-page-urls]');
    if (artistUrlsEl) {
      try {
        artistUrlMap = JSON.parse(artistUrlsEl.textContent) || {};
      } catch (e) {
        artistUrlMap = {};
      }
    }

    var loadingEl = app.querySelector('[data-artists-loading]');
    var errorEl = app.querySelector('[data-artists-error]');
    var mainEl = app.querySelector('[data-artists-main]');
    var gridEl = app.querySelector('[data-artists-grid]');
    var paginationWrapEl = app.querySelector('[data-artists-pagination-wrap]');
    var paginationCountEl = app.querySelector('[data-artists-pagination-count]');
    var loadMoreWrapEl = app.querySelector('[data-artists-load-more-wrap]');
    var loadMoreBtn = app.querySelector('[data-artists-load-more]');
    var targetRowsDesktop = parseInt(app.dataset.targetRowsDesktop, 10) || 5;
    var targetRowsMobile = parseInt(app.dataset.targetRowsMobile, 10) || 4;
    var cachedColumnCount = 1;

    function measureGridColumnCount() {
      if (!gridEl) return 1;
      var computed = window.getComputedStyle(gridEl).gridTemplateColumns;
      if (!computed || computed === 'none') return 1;
      var tracks = computed
        .trim()
        .split(' ')
        .filter(function (t) {
          return t;
        });
      return tracks.length || 1;
    }

    function currentPageSize() {
      var isMobile = window.matchMedia('(max-width: 959px)').matches;
      var targetRows = isMobile ? targetRowsMobile : targetRowsDesktop;
      return cachedColumnCount * targetRows;
    }

    var viewingTemplate = app.dataset.i18nViewing || "You're viewing {{ of }} of {{ total }}";
    var artistOneLabel = app.dataset.i18nArtistOne || 'Artist';
    var artistOtherLabel = app.dataset.i18nArtistOther || 'Artists';
    var countEl = app.querySelector('[data-results-count]');
    var sidebarForm = app.querySelector('[data-artists-filter-form]');
    var filterBarForm = app.querySelector('[data-artists-filter-bar]');
    var filterSidebarInner = sidebarForm ? sidebarForm.querySelector('.filter-sidebar-inner') : null;
    var sectionIdEl = sectionEl.querySelector('[data-section-id]');
    var sectionId = sectionIdEl
      ? sectionIdEl.getAttribute('data-section-id')
      : sectionEl.id.replace('shopify-section-', '');
    var filterDrawerEl = document.querySelector(
      '[data-artists-filter-drawer][data-section-id="' + sectionId + '"]'
    );
    if (filterDrawerEl && filterDrawerEl.parentNode !== document.body) {
      document.body.appendChild(filterDrawerEl);
    }
    var drawerFiltersInner = filterDrawerEl
      ? filterDrawerEl.querySelector('[data-artists-drawer-filters-inner]')
      : null;
    var drawerResultsCountEl = filterDrawerEl
      ? filterDrawerEl.querySelector('[data-artists-drawer-results-count]')
      : null;
    var sidebarToggleBtn = app.querySelector('[data-artists-sidebar-toggle]');
    var sortToggleBtn = app.querySelector('[data-artists-sort-toggle]');
    var sortDropdownEl = app.querySelector('[data-artists-sort-dropdown]');
    var sortLabelEl = app.querySelector('[data-sort-label]');
    var mqMobile = window.matchMedia('(max-width: 959px)');

    var catListEl = app.querySelector('[data-filter-category-list]');
    var medListEl = app.querySelector('[data-filter-medium-list]');
    var natListEl = app.querySelector('[data-filter-nationality-list]');
    var clearButtons = Array.prototype.slice.call(
      sectionEl.querySelectorAll('[data-artist-clear-filters]')
    );
    if (filterDrawerEl && !sectionEl.contains(filterDrawerEl)) {
      clearButtons = clearButtons.concat(
        Array.prototype.slice.call(
          filterDrawerEl.querySelectorAll('[data-artist-clear-filters]')
        )
      );
    }
    var artistSearchEl = app.querySelector('[data-artists-search]');
    var mobileActiveCountEl = app.querySelector('[data-artists-mobile-active-count]');
    var overallActiveCountEls = Array.prototype.slice.call(sectionEl.querySelectorAll('[data-artists-active-count]'));
    var groupActiveCountEls = Array.prototype.slice.call(sectionEl.querySelectorAll('[data-artists-group-count]'));
    var artistSearchTimer = null;
    var idSlug = String(sectionEl.id || 'artists').replace(/^shopify-section-/, '').replace(/[^a-zA-Z0-9_-]/g, '');
    var drawerCloseTimer = null;
    var lastDrawerTrigger = null;
    var activeDrawerPanel = null;
    var DRAWER_TRANSITION_MS = 500;

    function shouldAnimateDrawer() {
      return (
        sectionEl.classList.contains('animation') &&
        !document.documentElement.classList.contains('prefers-reduced-motion')
      );
    }

    var allArtists = [];
    var filtered = [];
    var visibleCount = currentPageSize();
    var facetValues = { category: [], medium: [], nationality: [] };
    var filterState = {
      search: '',
      category: new Set(),
      medium: new Set(),
      nationality: new Set(),
      sort: 'manual'
    };
    var isHydratingHistory = false;

    function readStateFromUrl() {
      var params = new URLSearchParams(window.location.search);
      filterState.search = params.get('artist_query') || '';
      ['category', 'medium', 'nationality'].forEach(function (facet) {
        filterState[facet] = new Set(params.getAll('artist_' + facet));
      });
      filterState.sort = params.get('artist_sort') || 'manual';
    }

    function writeStateToUrl(mode) {
      if (isHydratingHistory) return;
      var url = new URL(window.location.href);
      ['artist_query', 'artist_category', 'artist_medium', 'artist_nationality', 'artist_sort'].forEach(function (key) {
        url.searchParams.delete(key);
      });
      if (filterState.search) url.searchParams.set('artist_query', filterState.search);
      ['category', 'medium', 'nationality'].forEach(function (facet) {
        filterState[facet].forEach(function (value) {
          url.searchParams.append('artist_' + facet, value);
        });
      });
      if (filterState.sort && filterState.sort !== 'manual') url.searchParams.set('artist_sort', filterState.sort);
      var next = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
      if (next === window.location.pathname + window.location.search + window.location.hash) return;
      history[mode === 'replace' ? 'replaceState' : 'pushState']({ artistIndex: true }, '', next);
    }

    function syncControlsFromState() {
      if (artistSearchEl) artistSearchEl.value = filterState.search;
      if (filterSidebarInner) {
        filterSidebarInner.querySelectorAll('[data-artists-facet]').forEach(function (input) {
          var facet = input.getAttribute('data-artists-facet');
          input.checked = Boolean(filterState[facet] && filterState[facet].has(input.value));
        });
      }
      sectionEl.querySelectorAll('input[name^="artists_sort_by"]').forEach(function (input) {
        input.checked = input.value === filterState.sort;
      });
      if (filterDrawerEl) {
        filterDrawerEl.querySelectorAll('input[name^="artists_sort_by"]').forEach(function (input) {
          input.checked = input.value === filterState.sort;
        });
      }
    }

    function showError(msg) {
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }
      if (mainEl) mainEl.hidden = true;
      revealArtistIndexPage();
    }

    function showMain() {
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) errorEl.hidden = true;
      if (mainEl) mainEl.hidden = false;
      document.documentElement.style.setProperty('--sticky-filter-bar-height', '0px');
    }

    function apiFetch(variables) {
      return fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({ query: QUERY, variables: variables }),
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j && j.message ? j.message : 'HTTP ' + r.status);
          if (j.errors && j.errors.length) throw new Error(j.errors.map(function (e) { return e.message; }).join('; '));
          return j;
        });
      });
    }

    function loadAll() {
      var acc = [];
      var after = null;

      function next() {
        return apiFetch({ type: metaType, first: 100, after: after }).then(function (json) {
          var payload = getConnectionPayload(json);
          payload.nodes.forEach(function (node) {
            acc.push(normalizeArtist(node, artistUrlMap));
          });
          var pi = payload.pageInfo;
          if (pi.hasNextPage && pi.endCursor) {
            after = pi.endCursor;
            return next();
          }
          return acc;
        });
      }

      return next();
    }

    function facetCounts(artists, key) {
      var map = {};
      artists.forEach(function (a) {
        var vals = a[key];
        if (!vals || !vals.length) return;
        vals.forEach(function (v) {
          var k = String(v).trim();
          if (!k) return;
          map[k] = (map[k] || 0) + 1;
        });
      });
      return map;
    }

    function facetRowHtml(facet, value, count, idx, checked) {
      var id = 'artists-facet-' + facet + '-' + idSlug + '-' + idx;
      var dis = count === 0 && !checked;
      return (
        '<li class="filter-item">' +
        '<label data-filter-item class="filter-item__content' +
        (dis ? ' filter-item__content--disabled' : '') +
        '" for="' +
        id +
        '">' +
        '<input type="checkbox" class="filter-item__checkbox visually-hidden" data-filter-item-input data-artists-facet="' +
        facet +
        '" value="' +
        escAttr(value) +
        '" id="' +
        id +
        '"' +
        (checked ? ' checked' : '') +
        (dis ? ' disabled' : '') +
        '>' +
        '<div class="filter-item__content-inner">' +
        '<div class="filter-input__input">' +
        '<span class="icon icon-new icon-checkmark">' +
        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1.88 11.988 6.21 6.103L22.467 3.83" stroke="currentColor" stroke-width="3.055"></path></svg>' +
        '</span>' +
        '</div>' +
        '<span class="filter-item__label">' +
        escHtml(value) +
        '</span>' +
        '<span class="filter-item__count fs-body-75">(' +
        count +
        ')</span>' +
        '</div>' +
        '</label>' +
        '</li>'
      );
    }

    function getCheckedValues(ul, facet) {
      var checked = {};
      if (!filterState[facet]) return checked;
      filterState[facet].forEach(function (value) { checked[value] = true; });
      return checked;
    }

    function fillFacetList(ul, facet, values, candidateArtists) {
      if (!ul) return;
      var checkedValues = getCheckedValues(ul, facet);
      var counts = facetCounts(candidateArtists, facet);
      var visibleValues = values.filter(function (v) {
        return (counts[v] || 0) > 0 || checkedValues[v];
      });


      var group = ul.closest('.filter-drawer__group');
      var emptyState = group ? group.querySelector('[data-artists-empty-facet="' + facet + '"]') : null;
      if (group) {
        group.hidden = false;
        group.dataset.filterGroupUnavailable = visibleValues.length === 0 ? 'true' : 'false';
      }
      if (emptyState) emptyState.hidden = visibleValues.length !== 0;
      ul.hidden = visibleValues.length === 0;

      ul.innerHTML = visibleValues
        .map(function (v, idx) {
          var checked = Boolean(checkedValues[v]);
          return facetRowHtml(facet, v, counts[v] || 0, idx, checked);
        })
        .join('');
    }

    function refreshFacetLists() {
      fillFacetList(catListEl, 'category', facetValues.category, getMatchingArtists('category'));
      fillFacetList(medListEl, 'medium', facetValues.medium, getMatchingArtists('medium'));
      fillFacetList(natListEl, 'nationality', facetValues.nationality, getMatchingArtists('nationality'));
    }

    function selectedFacetValues(facet) {
      return filterState[facet] ? Array.from(filterState[facet]) : [];
    }

    function getCheckedSortInput() {
      if (mqMobile.matches && filterDrawerEl) {
        var mobileInp = filterDrawerEl.querySelector('input[name^="artists_sort_by"]:checked');
        if (mobileInp) return mobileInp;
      }
      return sectionEl.querySelector('input[name^="artists_sort_by"]:checked');
    }

    function getSortValue() {
      return filterState.sort || 'manual';
    }

    function updateSortLabel() {
      if (!sortLabelEl) return;
      var prefix = sortLabelEl.getAttribute('data-sort-title-prefix') || 'Sort';
      var inp = getCheckedSortInput();
      var optLabel = 'Featured';
      if (inp) {
        var wrap = inp.closest('label');
        var span = wrap && wrap.querySelector('.filter-item__label');
        if (span) optLabel = span.textContent.trim();
      }
      sortLabelEl.textContent = prefix + ': ' + optLabel;
    }

    function compareByName(a, b) {
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    }

    function sortArtistsList(list) {
      var sortBy = getSortValue();

      if (sortBy === 'title-descending') {
        list.sort(function (a, b) {
          return -compareByName(a, b);
        });
        return;
      }

      if (sortBy === 'date-added-descending') {
        list.sort(function (a, b) {
          var aHas = a.dateAdded != null;
          var bHas = b.dateAdded != null;
          if (aHas && bHas) {
            if (a.dateAdded !== b.dateAdded) return b.dateAdded - a.dateAdded;
            return compareByName(a, b);
          }
          if (aHas !== bHas) return aHas ? -1 : 1;
          return compareByName(a, b);
        });
        return;
      }

      if (sortBy === 'manual') {
        list.sort(function (a, b) {
          var aHas = a.featuredOrder != null;
          var bHas = b.featuredOrder != null;
          if (aHas && bHas) {
            if (a.featuredOrder !== b.featuredOrder) return a.featuredOrder - b.featuredOrder;
            return compareByName(a, b);
          }
          if (aHas !== bHas) return aHas ? -1 : 1;
          return compareByName(a, b);
        });
        return;
      }

      // title-ascending (and any unrecognized value) falls back to A-Z
      list.sort(compareByName);
    }

    function hasActiveFilters() {
      if (String(filterState.search || '').trim() !== '') return true;
      if (selectedFacetValues('category').length) return true;
      if (selectedFacetValues('medium').length) return true;
      if (selectedFacetValues('nationality').length) return true;
      return false;
    }

    function updateFiltersActiveClass() {
      var active = hasActiveFilters();
      if (filterBarForm) filterBarForm.classList.toggle('filters-active', active);
      clearButtons.forEach(function (button) {
        button.disabled = !active;
        button.classList.toggle('is-disabled', !active);
        button.setAttribute('aria-disabled', active ? 'false' : 'true');
      });
    }

    function clearArtistFilters() {
      visibleCount = currentPageSize();
      if (artistSearchTimer) {
        window.clearTimeout(artistSearchTimer);
        artistSearchTimer = null;
      }
      filterState.search = '';
      filterState.category.clear();
      filterState.medium.clear();
      filterState.nationality.clear();
      applyFilters({ historyMode: 'push' });
    }

    function syncSidebarToggleText() {
      if (!sidebarToggleBtn || !sidebarForm) return;
      var expanded = sidebarForm.getAttribute('aria-expanded') === 'true';
      var textEl = sidebarToggleBtn.querySelector('.filter-bar__button-text');
      var ex = sidebarToggleBtn.dataset.expandedTitle || 'Hide filters';
      var col = sidebarToggleBtn.dataset.collapsedTitle || 'Filter';
      sidebarToggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (textEl) textEl.textContent = expanded ? ex : col;
    }

    function setSidebarOpen(open) {
      if (!sidebarToggleBtn || !sidebarForm) return;
      sidebarForm.setAttribute('aria-expanded', open ? 'true' : 'false');
      sidebarToggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      syncSidebarToggleText();
    }

    function setSortDropdownOpen(open) {
      if (!sortToggleBtn || !sortDropdownEl || !filterBarForm) return;
      sortToggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      sortDropdownEl.setAttribute('aria-hidden', open ? 'false' : 'true');
      filterBarForm.classList.toggle('filter-bar--wash-active', open);
      var sortGroup = sortToggleBtn.closest('[data-artists-sort-group]');
      if (sortGroup) sortGroup.classList.toggle('filter-group--active', open);
    }

    function mountFiltersForBreakpoint() {
      var focusedFilterControl = filterSidebarInner && document.activeElement && filterSidebarInner.contains(document.activeElement)
        ? document.activeElement
        : null;
      // filterSidebarInner (category/medium/nationality/works) is one
      // shared DOM tree that is *moved*, not cloned, between the desktop sidebar
      // and the mobile drawer. Its own state (facet counts, checked values) only
      // needs to be updated once, on this single node — never assume there are
      // two copies to keep in sync. Also: this move takes filterSidebarInner
      // outside of `app` while it's parked in the drawer (which lives under
      // document.body), so anything that needs to keep working across both
      // locations — event listeners, element queries — must be scoped to
      // filterSidebarInner (or the specific list elements) directly, not to `app`.
      if (filterSidebarInner && sidebarForm && drawerFiltersInner) {
        if (mqMobile.matches) {
          if (filterSidebarInner.parentElement !== drawerFiltersInner) {
            drawerFiltersInner.appendChild(filterSidebarInner);
          }
          filterSidebarInner.dataset.mobileMounted = 'true';
        } else {
          if (filterSidebarInner.parentElement !== sidebarForm) {
            sidebarForm.appendChild(filterSidebarInner);
          }
          filterSidebarInner.dataset.mobileMounted = 'false';
        }
      }

      if (!mqMobile.matches) {
        closeArtistsFilterDrawer();
        setSortDropdownOpen(false);
      }
      if (focusedFilterControl && typeof focusedFilterControl.focus === 'function') {
        window.requestAnimationFrame(function () {
          focusedFilterControl.focus({ preventScroll: true });
        });
      }
    }

    function getFocusableElements(panel) {
      if (!panel) return [];
      return Array.prototype.slice.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) {
        return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.offsetParent !== null;
      });
    }

    function setDrawerTriggerState(trigger, open) {
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function finishDrawerClose() {
      if (!filterDrawerEl) return;
      filterDrawerEl.classList.remove('is-fixed');
      activeDrawerPanel = null;
      if (lastDrawerTrigger && typeof lastDrawerTrigger.focus === 'function') {
        lastDrawerTrigger.focus({ preventScroll: true });
      }
      lastDrawerTrigger = null;
    }

    function closeArtistsFilterDrawer() {
      if (!filterDrawerEl) return;
      var flyouts = filterDrawerEl.querySelectorAll('[data-filter-modal]');
      flyouts.forEach(function (panel) {
        panel.classList.remove('active', 'animation--filter-bar-revealed');
        panel.setAttribute('aria-hidden', 'true');
      });
      setDrawerTriggerState(lastDrawerTrigger, false);
      filterDrawerEl.classList.remove('active');
      document.body.removeAttribute('data-fluorescent-overlay-open');
      document.body.style.overflow = '';
      var backToTopEl = document.querySelector('[data-back-to-top]');
      if (backToTopEl) backToTopEl.style.pointerEvents = '';
      if (drawerCloseTimer) clearTimeout(drawerCloseTimer);

      var completed = false;
      function complete() {
        if (completed) return;
        completed = true;
        finishDrawerClose();
      }
      var panel = activeDrawerPanel;
      if (panel) panel.addEventListener('transitionend', complete, { once: true });
      drawerCloseTimer = setTimeout(function () {
        complete();
        drawerCloseTimer = null;
      }, DRAWER_TRANSITION_MS + 100);
    }

    function openArtistsFilterDrawer(target, trigger) {
      if (!filterDrawerEl || !target) return;
      var modal = filterDrawerEl.querySelector('[data-filter-modal="' + target + '"]');
      if (!modal) return;

      if (drawerCloseTimer) {
        clearTimeout(drawerCloseTimer);
        drawerCloseTimer = null;
      }
      if (lastDrawerTrigger && lastDrawerTrigger !== trigger) setDrawerTriggerState(lastDrawerTrigger, false);
      lastDrawerTrigger = trigger || lastDrawerTrigger;
      activeDrawerPanel = modal;
      setDrawerTriggerState(lastDrawerTrigger, true);

      filterDrawerEl.querySelectorAll('[data-filter-modal]').forEach(function (panel) {
        if (panel !== modal) {
          panel.classList.remove('active', 'animation--filter-bar-revealed');
          panel.setAttribute('aria-hidden', 'true');
        }
      });

      filterDrawerEl.classList.add('is-fixed');
      document.body.setAttribute('data-fluorescent-overlay-open', 'true');
      document.body.style.overflow = 'hidden';
      var backToTopEl = document.querySelector('[data-back-to-top]');
      if (backToTopEl) backToTopEl.style.pointerEvents = 'none';

      setTimeout(function () {
        if (shouldAnimateDrawer()) modal.classList.add('animation--filter-bar-revealed');
        filterDrawerEl.classList.add('active');
        modal.classList.add('active');
        modal.setAttribute('aria-hidden', 'false');
        var focusable = getFocusableElements(modal);
        if (focusable.length) focusable[0].focus({ preventScroll: true });
      }, 0);
    }

    function initArtistsFilterDrawer() {
      if (!filterDrawerEl) return;

      var drawerWash = filterDrawerEl.querySelector('[data-drawer-wash]');
      var closeTargets = filterDrawerEl.querySelectorAll('[data-close-icon], [data-button="close"]');

      sectionEl.addEventListener(
        'click',
        function (e) {
          var trigger = e.target.closest('[data-filter-drawer-target]');
          if (!trigger || !app.contains(trigger)) return;
          e.preventDefault();
          var target = trigger.getAttribute('data-filter-drawer-target');
          if (!target) return;
          setSortDropdownOpen(false);
          openArtistsFilterDrawer(target, trigger);
        },
        { signal: signal }
      );

      if (drawerWash) {
        drawerWash.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            closeArtistsFilterDrawer();
          },
          { signal: signal }
        );
      }

      closeTargets.forEach(function (btn) {
        btn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            closeArtistsFilterDrawer();
          },
          { signal: signal }
        );
      });

      filterDrawerEl.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Escape' || e.keyCode === 27) {
            e.preventDefault();
            closeArtistsFilterDrawer();
            return;
          }
          if (e.key === 'Tab' && activeDrawerPanel) {
            var focusable = getFocusableElements(activeDrawerPanel);
            if (!focusable.length) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        },
        { signal: signal }
      );

      filterDrawerEl.addEventListener(
        'change',
        function (e) {
          var t = e.target;
          if (t && t.matches && t.matches('input[name^="artists_sort_by"]')) {
            filterState.sort = t.value || 'manual';
            updateSortLabel();
            applyFilters({ historyMode: 'push' });
          }
        },
        { signal: signal }
      );

    }

    function bindDrawerToggles(root) {
      if (!root) return;
      root.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest('[data-artists-group-toggle]');
          if (!btn || !root.contains(btn)) return;
          e.preventDefault();
          var panelId = btn.getAttribute('aria-controls');
          if (!panelId) return;
          var panel = root.querySelector('#' + window.CSS.escape(panelId));
          if (!panel) return;
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.setAttribute('aria-hidden', open ? 'true' : 'false');
          var group = btn.closest('.filter-drawer__group');
          if (group) group.dataset.userCollapsed = open ? 'true' : '';
        },
        { signal: signal }
      );
    }

    function getMatchingArtists(excludedFacet) {
      var cats = selectedFacetValues('category');
      var meds = selectedFacetValues('medium');
      var nats = selectedFacetValues('nationality');

      var searchTerm = String(filterState.search || '').trim().toLocaleLowerCase();

      return allArtists.filter(function (a) {
        if (searchTerm && String(a.name || '').toLocaleLowerCase().indexOf(searchTerm) === -1) return false;

        if (excludedFacet !== 'category' && cats.length) {
          var hitC = cats.some(function (c) {
            return a.category.indexOf(c) !== -1;
          });
          if (!hitC) return false;
        }

        if (excludedFacet !== 'medium' && meds.length) {
          var hitM = meds.some(function (m) {
            return a.medium.indexOf(m) !== -1;
          });
          if (!hitM) return false;
        }

        if (excludedFacet !== 'nationality' && nats.length) {
          var hitN = nats.some(function (n) {
            return a.nationality.indexOf(n) !== -1;
          });
          if (!hitN) return false;
        }

        return true;
      });
    }

    function getActiveFilterCount() {
      var count = 0;
      count += selectedFacetValues('category').length;
      count += selectedFacetValues('medium').length;
      count += selectedFacetValues('nationality').length;
      if (String(filterState.search || '').trim() !== '') count += 1;
      return count;
    }

    function updateActiveCounts() {
      var count = getActiveFilterCount();
      if (mobileActiveCountEl) {
        mobileActiveCountEl.textContent = count > 0 ? String(count) : '';
        mobileActiveCountEl.hidden = count === 0;
        mobileActiveCountEl.setAttribute('aria-hidden', 'true');
      }
      overallActiveCountEls.forEach(function (el) {
        el.textContent = count > 0 ? String(count) : '';
        el.hidden = count === 0;
        el.setAttribute('aria-hidden', 'true');
      });
      groupActiveCountEls.forEach(function (el) {
        var facet = el.getAttribute('data-artists-group-count');
        var groupCount = filterState[facet] ? filterState[facet].size : 0;
        el.textContent = groupCount > 0 ? String(groupCount) : '';
        el.hidden = groupCount === 0;
        el.setAttribute('aria-hidden', 'true');
      });
    }

    function updateActiveSummaries() {
      ['category', 'medium', 'nationality'].forEach(function (facet) {
        var summary = filterSidebarInner
          ? filterSidebarInner.querySelector('[data-artists-active-summary="' + facet + '"]')
          : null;
        if (!summary) return;
        var values = selectedFacetValues(facet);
        summary.textContent = values.join(', ');
        summary.hidden = values.length === 0;

        var group = summary.closest('.filter-drawer__group');
        var toggle = group ? group.querySelector('[data-artists-group-toggle]') : null;
        var panel = toggle && toggle.getAttribute('aria-controls')
          ? group.querySelector('#' + window.CSS.escape(toggle.getAttribute('aria-controls')))
          : null;
        if (values.length && toggle && panel && !group.dataset.userCollapsed) {
          toggle.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        }
      });

      var searchSummary = filterSidebarInner
        ? filterSidebarInner.querySelector('[data-artists-search-summary]')
        : null;
      if (searchSummary) {
        var query = String(filterState.search || '').trim();
        searchSummary.textContent = query ? 'Search: “' + query + '”' : '';
        searchSummary.hidden = !query;
      }
    }

    function applyFilters(options) {
      options = options || {};
      syncControlsFromState();
      filtered = getMatchingArtists(null);

      sortArtistsList(filtered);
      visibleCount = currentPageSize();
      refreshFacetLists();
      render();
      updateFiltersActiveClass();
      updateActiveCounts();
      updateActiveSummaries();
      if (options.updateUrl !== false) writeStateToUrl(options.historyMode || 'push');
    }

    function viewingRangeText(total, end) {
      var start = total > 0 ? 1 : 0;
      var ofRange = start + '-' + end;
      return viewingTemplate
        .replace(/\{\{\s*of\s*\}\}/g, ofRange)
        .replace(/\{\{\s*total\s*\}\}/g, String(total))
        .trim();
    }

    function updatePaginationUi(total, shown) {
      if (!paginationWrapEl) return;
      if (!total) {
        paginationWrapEl.hidden = true;
        if (loadMoreWrapEl) loadMoreWrapEl.hidden = true;
        return;
      }
      paginationWrapEl.hidden = false;
      if (paginationCountEl) {
        paginationCountEl.textContent = viewingRangeText(total, shown) + ' ' + artistOtherLabel.toLowerCase();
      }
      if (loadMoreWrapEl) {
        loadMoreWrapEl.hidden = shown >= total;
      }
    }

    function render() {
      var total = filtered.length;
      var shown = Math.min(visibleCount, total);
      var page = filtered.slice(0, shown);

      var countText = total + ' ' + (total === 1 ? artistOneLabel : artistOtherLabel);
      if (countEl) countEl.textContent = countText;
      if (drawerResultsCountEl) drawerResultsCountEl.textContent = countText;

      updatePaginationUi(total, shown);

      if (gridEl) {
        gridEl.innerHTML = page
          .map(function (a) {
            var href = escAttr(a.collectionUrl);
            var nameEsc = escHtml(a.name);
            var hasHover = Boolean(a.hoverUrl);
            var cardClass = 'artists-index__card' + (hasHover ? ' artists-index__card--has-hover' : '');

            var primary = a.portraitUrl
              ? '<img class="artists-index__card-img artists-index__card-img--primary" src="' +
                escAttr(a.portraitUrl) +
                '" alt="' +
                escAttr(a.portraitAlt || a.name) +
                '" loading="lazy" width="600" height="800" sizes="(min-width: 960px) 200px, 45vw">'
              : '<div class="artists-index__card-img artists-index__card-img--placeholder artists-index__card-img--primary" aria-hidden="true"></div>';

            var hoverImg = '';
            if (hasHover) {
              hoverImg =
                '<img class="artists-index__card-img artists-index__card-img--hover" src="' +
                escAttr(a.hoverUrl) +
                '" alt="" loading="lazy" width="600" height="800" sizes="(min-width: 960px) 200px, 45vw" aria-hidden="true">';
            }

            return (
              '<div class="' +
              cardClass +
              '" role="listitem">' +
              '<div class="artists-index__card-media">' +
              primary +
              hoverImg +
              '</div>' +
              '<a class="artists-index__card-name ff-heading fs-heading-6-base" href="' +
              href +
              '">' +
              nameEsc +
              '</a></div>'
            );
          })
          .join('');
      }
    }

    function bind() {

      if (artistSearchEl) {
        artistSearchEl.addEventListener(
          'input',
          function () {
            filterState.search = String(artistSearchEl.value || '').trim();
            window.clearTimeout(artistSearchTimer);
            artistSearchTimer = window.setTimeout(function () {
              artistSearchTimer = null;
              applyFilters({ historyMode: 'replace' });
            }, 180);
          },
          { signal: signal }
        );
      }

      if (filterSidebarInner) {
        filterSidebarInner.addEventListener(
          'change',
          function (e) {
            var t = e.target;
            if (!t) return;
            if (t.matches && t.matches('[data-artists-facet]')) {
              var facet = t.getAttribute('data-artists-facet');
              if (filterState[facet]) {
                if (t.checked) filterState[facet].add(t.value);
                else filterState[facet].delete(t.value);
              }
              applyFilters({ historyMode: 'push' });
            }
          },
          { signal: signal }
        );
      }
      bindDrawerToggles(filterSidebarInner);

      sectionEl.addEventListener(
        'change',
        function (e) {
          var t = e.target;
          if (t && t.matches && t.matches('input[name^="artists_sort_by"]')) {
            filterState.sort = t.value || 'manual';
            updateSortLabel();
            applyFilters({ historyMode: 'push' });
          }
        },
        { signal: signal }
      );

      if (sidebarToggleBtn && sidebarForm) {
        syncSidebarToggleText();
        sidebarToggleBtn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            var open = sidebarForm.getAttribute('aria-expanded') !== 'true';
            setSidebarOpen(open);
          },
          { signal: signal }
        );
      }

      if (sortToggleBtn && sortDropdownEl) {
        sortToggleBtn.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            if (mqMobile.matches) {
              closeArtistsFilterDrawer();
              openArtistsFilterDrawer('__sort');
              return;
            }
            var open = sortToggleBtn.getAttribute('aria-expanded') !== 'true';
            setSortDropdownOpen(open);
          },
          { signal: signal }
        );
      }

      app.addEventListener(
        'click',
        function (e) {
          if (!sortToggleBtn || !sortDropdownEl) return;
          if (sortToggleBtn.getAttribute('aria-expanded') !== 'true') return;
          var mf = e.target.closest('[data-mobile-filters]');
          if (mf && app.contains(mf)) return;
          var g = sortToggleBtn.closest('[data-artists-sort-group]');
          if (g && g.contains(e.target)) return;
          setSortDropdownOpen(false);
        },
        { signal: signal }
      );

      var wash = sectionEl.querySelector('[data-artists-filter-bar-wash]');
      if (wash && filterBarForm) {
        wash.addEventListener(
          'click',
          function () {
            setSortDropdownOpen(false);
          },
          { signal: signal }
        );
      }

      document.addEventListener(
        'keydown',
        function (e) {
          if ((e.key === 'Escape' || e.keyCode === 27) && sortToggleBtn && sortToggleBtn.getAttribute('aria-expanded') === 'true') {
            setSortDropdownOpen(false);
            sortToggleBtn.focus({ preventScroll: true });
          }
        },
        { signal: signal }
      );

      setSidebarOpen(true);
      setSortDropdownOpen(false);
      app.dataset.artistsIndexInitialized = 'true';

      initArtistsFilterDrawer();
      mountFiltersForBreakpoint();
      if (mqMobile.addEventListener) {
        mqMobile.addEventListener('change', mountFiltersForBreakpoint, { signal: signal });
      } else if (mqMobile.addListener) {
        mqMobile.addListener(mountFiltersForBreakpoint);
      }

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener(
          'click',
          function () {
            visibleCount += currentPageSize();
            render();
          },
          { signal: signal }
        );
      }

      function bindClearButtons(root) {
        if (!root) return;
        root.addEventListener(
          'click',
          function (event) {
            var button = event.target.closest('[data-artist-clear-filters]');
            if (!button || !root.contains(button)) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
            clearArtistFilters();
          },
          { signal: signal, capture: true }
        );
      }

      bindClearButtons(sectionEl);
      if (filterDrawerEl && !sectionEl.contains(filterDrawerEl)) {
        bindClearButtons(filterDrawerEl);
      }

      updateSortLabel();
    }

    bind();

    window.addEventListener('popstate', function () {
      isHydratingHistory = true;
      readStateFromUrl();
      syncControlsFromState();
      applyFilters({ updateUrl: false });
      isHydratingHistory = false;
    }, { signal: signal });

    if (window.ResizeObserver && gridEl) {
      var lastObservedWidth = null;
      var gridResizeObserver = new ResizeObserver(function (entries) {
        var entry = entries && entries[0];
        var width = entry ? entry.contentRect.width : gridEl.getBoundingClientRect().width;
        var roundedWidth = Math.round(width);

        if (lastObservedWidth !== null && roundedWidth === lastObservedWidth) {
          return;
        }
        lastObservedWidth = roundedWidth;
        cachedColumnCount = measureGridColumnCount();

        var target = currentPageSize();
        if (target > 0 && target !== visibleCount && allArtists.length) {
          visibleCount = target;
          render();
        }
      });
      gridResizeObserver.observe(gridEl);
    }

    loadAll()
      .then(function (rows) {
        allArtists = rows;
        var catSet = [];
        var medSet = [];
        var natSet = [];
        allArtists.forEach(function (a) {
          catSet = catSet.concat(a.category);
          medSet = medSet.concat(a.medium);
          natSet = natSet.concat(a.nationality);
        });
        facetValues.category = uniqSort(catSet);
        facetValues.medium = uniqSort(medSet);
        facetValues.nationality = uniqSort(natSet);
        readStateFromUrl();
        syncControlsFromState();
        showMain();
        cachedColumnCount = measureGridColumnCount();
        applyFilters({ updateUrl: false });
        document.dispatchEvent(new CustomEvent('artists:index-ready'));
      })
      .catch(function (err) {
        showError(err && err.message ? err.message : 'Could not load artists.');
      });
  };
})();